import { SEO_SIGN_UP_DESCRIPTION, SEO_SIGN_UP_TITLE } from 'src/constants';
import { MainEmailSignupSection } from 'src/v2/pages/auth/components/MainEmailSignupSection';
import { BaseSignPage } from 'src/v2/pages/auth/BaseSignPage';

export const SignupWithEmailPage = () => {
  return (
    <BaseSignPage
      seoTitle={SEO_SIGN_UP_TITLE}
      seoDescription={SEO_SIGN_UP_DESCRIPTION}
    >
      <>
        <MainEmailSignupSection />
      </>
    </BaseSignPage>
  );
};
